import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { PrimaryButton } from 'components/lib/buttons/Button';
import { AddSeriesBtn, ClearCompareBtn } from 'components/lib/buttons/IconButtons';
import SeriesComparisonControlledSelect from 'components/lib/formElements/SeriesComparisonControlledSelect';
import CallOut from 'components/lib/containers/CallOut';
import ComparedSeries from 'components/lib/cards/ComparedSeries';
import styles from 'styles/components/series/SeriesComparisonChart.css';

const LegendSection = props => (
  <CallOut>
    {/* SERIES 1 */}
    <ComparedSeries
      color={props.colors['series1']}
      seriesName={(props.series1LegendData) ? props.series1LegendData.name : '---'}
      total={(props.series1LegendData) ? numeral(props.series1LegendData.ticketRevenue).format('$0,0.00') : '---'}
      avgPrice={(props.series1LegendData) ? props.getAverageTicketPrice(props.series1LegendData.id) : '---'} />
    {/* SERIES 2 */}
    { props.displaySeries2 &&
      (props.selectedSeries2 ?
        (
          <ComparedSeries
            color={props.colors['series2']}
            seriesName={(props.displaySeries2) ? props.productionNamesObj[props.selectedSeries2] : '---'}
            seriesType="SERIES2"
            total={(props.series2LegendData) ? numeral(props.series2LegendData.ticketRevenue).format('$0,0.00') : '---'}
            avgPrice={(props.series2LegendData) ? props.getAverageTicketPrice(props.series2LegendData.id) : '---'}
            hasClearButton={true}
            onClear={props.onClear} />
        ) : (
          <SeriesComparisonControlledSelect
            clientId={props.clientId}
            error={props.error}
            productions={props.productions}
            handleMenu={props.handleMenu}
            isDialog={false}
            label={null}
            onChange={props.changeSeries2}
            openMenu={props.openMenu}
            selectedItemName={""}
            selectedIds={[props.series1LegendData.id, props.selectedSeries2, props.selectedSeries3]} />
        )
      )
    }
    {/* SERIES 3 */}
    { props.displaySeries3 &&
      (props.selectedSeries3 ?
        (
          <ComparedSeries
            color={props.colors['series3']}
            seriesName={(props.displaySeries3) ? props.productionNamesObj[props.selectedSeries3] : '---'}
            seriesType="SERIES3"
            total={(props.series3LegendData) ? numeral(props.series3LegendData.ticketRevenue).format('$0,0.00') : '---'}
            avgPrice={(props.series3LegendData) ? props.getAverageTicketPrice(props.series3LegendData.id) : '---'}
            hasClearButton={true}
            series3={true}
            onClear={props.onClear} />
        ) : (
          <SeriesComparisonControlledSelect
            clientId={props.clientId}
            error={props.error}
            productions={props.productions}
            handleMenu={props.handleMenu}
            isDialog={false}
            label={null}
            onChange={props.changeSeries3}
            openMenu={props.openMenu}
            selectedItemName={""}
            series1={props.series1LegendData.name}
            selectedIds={[props.series1LegendData.id, props.selectedSeries2, props.selectedSeries3]} />
        )
      )
    }
    {/* Add Series Button */}
    { props.displayAddSeries &&
      <div className={styles.addSeriesContainer}>
        <AddSeriesBtn onClick={props.toggleAdditionalSeries} />
      </div>
    }
    {/* COMPARE BUTTON */}
    {/*<div className={styles.compareButton}>
      <PrimaryButton onClick={props.handleSeriesCompare} style={{width:"100%"}} label="Compare" />
    </div>*/}
  </CallOut>
)

export default LegendSection;



// WEBPACK FOOTER //
// ./src/scripts/components/series/seriesComparison/LegendSection.js